<template>
  <v-container fluid class="px-0">
    <v-card class="card px-4 py-3 mb-4">
      <DetailFindingPrint
        :finding="finding"
        :findingNumber="findingNumber"
        :routineId="routineId"
      />
      <div class="d-flex">
        <ImageMedia
          v-for="(media, index) in mediaObjects"
          class="imageMedia mr-2"
          :key="index"
          :width="132"
          :height="132"
          :src="media"
          :size="IMAGE_SIZES.CARD"
        />
      </div>
    </v-card>
  </v-container>
</template>
<script>
import DetailFindingPrint from './DetailFindingPrint.vue'
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import { IMAGE_SIZES } from 'rever-media-sdk'

export default {
  name: 'ListFinding',
  components: {
    DetailFindingPrint,
    ImageMedia,
  },
  props: {
    finding: {
      type: Object,
      required: true,
    },
    findingNumber: Number,
    routineId: String,
  },
  data() {
    return {
      IMAGE_SIZES,
    }
  },
  computed: {
    mediaObjects() {
      return this.finding?.media || []
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  border: 1px solid $color-blue-grey-darken1;
  min-height: 298px;
}
</style>
